import React, { useState } from 'react';
import ExamListView from './ExamListView';
import ExamForm from './ExamForm';
import ExamDetails from './ExamDetails';
import ResultsEntryForm from './ResultsEntryForm';
import ResultsDashboard from './ResultsDashboard';

const Exams = () => {
  const [currentView, setCurrentView] = useState('exam-list'); 
  const [selectedExam, setSelectedExam] = useState(null);
  const [showResultsEntry, setShowResultsEntry] = useState(false);
  const [showResultsDashboard, setShowResultsDashboard] = useState(false);

  const handleCreateExam = () => {
    setSelectedExam(null);
    setCurrentView('exam-form');
  };

  const handleEditExam = (exam) => {
    setSelectedExam(exam);
    setCurrentView('exam-form');
  };

  const handleBackToExams = () => {
    setCurrentView('exam-list');
    setSelectedExam(null);
  };

  const handleExamSubmit = () => {
    setCurrentView('exam-list');
    setSelectedExam(null);
  };

  const handleViewExamDetails = (exam) => {
    setSelectedExam(exam);
    setCurrentView('exam-details');
  };

  const handleOpenResultsEntry = (exam) => {
    setSelectedExam(exam);
    setShowResultsEntry(true);
  };

  const handleOpenResultsDashboard = (exam) => {
    setSelectedExam(exam);
    setShowResultsDashboard(true);
  };

  const handleCloseResultsEntry = () => {
    setShowResultsEntry(false);
    setSelectedExam(null);
  };

  const handleCloseResultsDashboard = () => {
    setShowResultsDashboard(false);
    setSelectedExam(null);
  };

  const handleResultsEntrySubmit = () => {
    setShowResultsEntry(false);
    setSelectedExam(null);
  };

  return (
    <div className="bg-gray-50/30 min-h-screen">
      {currentView === 'exam-list' && (
        <ExamListView 
          onCreateExam={handleCreateExam}
          onEditExam={handleEditExam}
          onViewExamDetails={handleViewExamDetails}
        />
      )}
      
      {currentView === 'exam-form' && (
        <ExamForm
          exam={selectedExam}
          onBack={handleBackToExams}
          onSubmit={handleExamSubmit}
        />
      )}

      {currentView === 'exam-details' && (
        <ExamDetails
          exam={selectedExam}
          onBack={handleBackToExams}
          onEdit={handleEditExam}
          onDelete={(examId) => {
            handleBackToExams();
          }}
          onViewResults={() => setCurrentView('results-dashboard')}
          onAddResults={() => setCurrentView('results-entry')}
        />
      )}

      {currentView === 'results-entry' && (
        <ResultsEntryForm
          exam={selectedExam}
          onClose={() => setCurrentView('exam-details')}
          onSubmit={() => setCurrentView('exam-details')}
        />
      )}

      {currentView === 'results-dashboard' && (
        <ResultsDashboard
          exam={selectedExam}
          onBack={() => setCurrentView('exam-details')}
        />
      )}
    </div>
  );
};

export default Exams;
